export class HelperService {
    static getAgeSelectOptions() {
        return [
            '1 yr',
            '2 yrs',
            '3 yrs',
            '4 yrs',
            '5 yrs',
            '6 yrs',
            '7 yrs',
            '8 yrs',
            'Other'
        ];
    }
    static getISOStringFromDDMMYYY(date) {
        if (!date) {
            return '';
        }
        const separator = date.includes('-') ? '-' : '/';
        const parts = date.split(separator);
        if (parts.length !== 3) {
            return '';
        }
        const [first, month, third] = parts;
        const year = separator === '-' ? first : third;
        const day = separator === '-' ? third : first;
        return `${year}-${month}-${day}T00:00:00.000Z`;
    }
    static goToTop() {
        window.scrollTo(0, 0);
    }
    static redirectTo(url) {
        window.location.assign(url);
    }
}
